export interface MatchingPreset {
    label: string;
    productKey: string;
    productVersion: number;
    culture: string;
    documentSourceUri: string;
    productOptions: Record<string, string>;
    siteResultUri?: string;
    dpcId?: string;
}

const SHARED_DOCUMENT_SOURCE_URI = 'https://storage.documents.cimpress.io/v3/documents/transient?document=7VprbxvHFf0rwn4oWkBDzfshICgUx7KdRLETq24RwzDmKW603KWXSymyofz23llS4sMsa9KC0cCVPmg5s3t35px779x7xA%2FFVWwnZVMXxwUd4OKwSE3d%2FRLHzaTsmvbmH20FM8OuG0%2BOj47y3GQQGj8dxXzly9G4jZPJoGyOrshRe%2FdYGSdH2DJHkrNIJysRZ5Eg7VlEFhNtRXSaCHw0nrqqnAxjgBffmS2OPxRjW8dqUhy%2F%2FlCUARYguNaeEopCUAFxrjwyzBgUXJDEUCMj701E37S2g%2B2cRz%2Bsm6q5uIGnm5QmsXvefldelJ2t4MbajiJMnLawIfh4XYZuCJ8NGWiz%2FDMawewwlhfDLq%2BCDXQ%2F4sFye9aEbKO%2FhrFyZC%2Fi0pJDxBYHGhAxAAKniSPrFUZKieRcECTp9PZqXE3elqOLtwQsAJRXZbxehXw6rhobtoA%2Bv%2BEoOkuFF%2FCqoDjgLRSykTikuXWEBYM1k38Qio%2BAnouyttXR37tY27r75spNka%2F%2BcjUuwzdGKinpbDVl3e25FuadVVwkZDyOiGshkaHBI26F1ckH%2BMN2Wcv7Z3WIvxfHDGNYWPax3mM%2FFDBWsAFjTMyIyWwzOaCGatEP3DGrxYCB4%2FFVQskAC80YDN7CKCzmPfiDrU6q8qKeuWJRxZQ9BKKkK%2F3qVNeMYaZtut7jTuqLCvwB3745LLr4e3fSRjtzhz0Nu6rxl6dVc%2F1d2UY%2F2%2FGSLdS5JWT4JmQoGUisJL%2BHRg%2Bk0litICP5ACuh5ZqrDwQmXM2QWd%2Fi4czDvSYqSkyQDQGCEiIHGYkZBKUyRmsVNQkzD894vGV94NRdv0eAJSeTUzsqq7yy07K1By9tPZlnoJfdTX5VUTftqI%2FYfrB8n8cIG3fLtopX5aSzvb%2FexWZe3ejm8q%2BKHHJyiA%2BJ%2BBtMVWUdny64J5IQFmGHb24PvwxL4pNYImxguKB0lSYxUIbhNZrgTk2Z3EoTT0Z7TS3CxiWgiUAOllIhGYWz2ngmvF2iiW%2Bj6efzg%2BdVeNJMw80nEGXWeFpnBx%2FmX7WRG6PVl%2BVGbuKGQ8BwRha5RQ%2BUUFSuUMP1QAuj6O7UkOSjlEQirAVF3AiDnOYRCZYYZUoLEtMSNeIrpUZ9CjWcDrgknD0QNUE4qCsoQc6RfJwahwymDGmcoiLSUErJEjXyT0NN29%2F9YNzoTdwISFZMa7MgR0K2FRKvkMMg8Umiye7kaHhMSSKQBRYQT4oiayhGMSVJffCOumVy1NdKjtlEDpRHwMU9NRTqJy3YatxoWK7mZK3%2BhZDTlLLtpw0UBI5Tj4h1UPbjABHETEDKYy88pjREtUSNfrCigKwx830TD07GY3jgoWuCByaJ4M3pTQipFumNqoGmhKxVtXSgITXp3SPISsohViTSWkLtZiV0Jy4YFCWjUCLgpIlcosl8rRFEyKeQA5mMQf3LHoicYJWPTEpEsIWmiUCJbSiniFoegg2KOrUcQwT%2Fadh52LoAOsjN5MD5QLafPVAYGK7MHoUBV4QmKSCjpQSRoxJGWkCrS5Qz0G8zruhyzUbI%2Fxo50J9OhnbcaxVwXXZx9EtMsY21vxubTN29AtOzOcsZ3EN%2F5wNyiUFqh1QBV84j5pOxlCTFkttDhPnW%2BsvP1GBcZevLZQ1mrQffecuw6WIUOxtsZ7NfhVCmV2tCGRgZV7aLPavZbSf5zq6F8yoBecVxstUkgiG4y8dhU4UITHXtNM4X%2BkPsuz1tBMtNV48xltEr7TEKKuslAmpPOHI1gh5NEUj%2FiSq8UI0oPHYnoZzPl%2FO4ijminmVrNFDsoRZCzDAFvgpXToG17KcpCROsMcvWMtWfvJN%2BcGUrC8HGXtmysq6Kp2Wd9b2Mag9oVZU%2Biya2nMTwDEgD6K9sW%2Fb%2B0r%2B2vXCPwJl7FfD%2FgtjGtcyds8fys2EiPlCLHXQ21sHSeAKEIL8h54MS1liOLflSMBHiAA4jUIi56RJQnxgRKAKygnZUWEHxTjAt%2FOzzcdI6aZUkip5giCUOh7JJFkmStLaROhvNl8KJ4miwgEDmCmo2Hj1FhmTEwDaLhjJv6Q443R7uK1lvSz6QwRiciQQp4%2FLSoHm2BFbqtNKJUUxNYMvWdko%2BxaNmBPn65uCnfIjAcQfOW308PJ62UB7MZPp%2Bop6N75Sf9hU7t4EDcWaMDxwxboFGZyWygkcURVTaBc%2BT5ivm9kPnDHwH0vMGgBYzH2E0up%2FaHaY9xMZtMEXiTYpBA8wezBFikJPg8pSIQKBKhm4lrJjbDaaTEHJ0HfwIxdIBWULpo4kFSHY2tfMpt6%2FgtxUepTEVEZptJeAw4TxAF2cVEtIRFZzznosVc58BD%2F1P8NBN8NC94NlDdNsGD44%2BOCrBXZxmAA%2FkbU2chhCOmmMmSLBsxdxu8LwYNrD9o4Pn3TC2S%2Bisjy%2FAGeeZvZDZQ%2FHahowhFhsG6QvqEUBGUYG0VAIC1iVpDQ%2FOuhVzuyFzOq2q9cy8PLZAJMHo3jl5D61pGygEzJgYWT5QAWMDyUYbZVGEOAJIAGHnVsztBsr3jTs4L7tqGZTlsQUovzWumw%2FuDsoeys7Wg8qmBBWgQQLDUc6hBYSmz2JkmbTSqcg1xSvmdgPl8Qj2tyGG1scX4MQ8s1922UNW2QZNokESh6GiMRyqMJx7C%2BsUClRoqyw1jK3Z2w2bf0a3AZnV0QUu19HtF0R76BnbUFEOhxgh1SoGrsexgqD0zMKZRG1SjjlrxKq9rEjclbwvm2nb9%2BR7fwdk0luA%2B88fn7348eT88dvz5z88%2FikLE30zX0D5zik1ZDBIxgtoKyDCMYfqggqo7gycFDJCVoFWhCsdejmrsG133bSXT2IdZ9JG36nGd9M4mfuCcd56bZFN1ORiF%2FKzyKkVKsNEHSZR59Nq%2FkhPb2ZrXM4655fpyZUY%2FareffvkbJquL2%2FePX1Bgp7GV8lclL%2F9KzzN%2BtAktldlv7eTj9bTt4TDJsxLvOwTh4UH2h8NbVn3KG64YY8tTDt%2FXo7iy86OxlligAIEAgpRek7UMebH%2Bf9w1Pw6wy346uxeRulllm4aymYx9mHV63vil76RlN8363myH%2B%2FedhvohaKjiLlctMM%2BkA6YI0yETD5RQVP6g5D%2F0ifNFZo3Gc%2F6yk76oHrdi41zIbgXGmX%2BHgoT90oW4QOuWJ68E69mI1Jt0hZ924z7rJD%2FFDn1tHPFK1%2B7puua0fxDL6Lmy9uFFNorobNtQ085H8R7ikoQkDWcy5nAWcv8rJ507dTPNZrXb25v%2Fw0%3D';

export const MATCHING_PRESETS: MatchingPreset[] = [
    {
        label: 'Business Cards - NA',
        productKey: 'PRD-IYXT1T3V',
        productVersion: 52,
        culture: 'en-us',
        documentSourceUri: SHARED_DOCUMENT_SOURCE_URI,
        productOptions: {
            Thickness: 'Premium',
            Substrate: 'Bamboo',
            Shape: 'Square',
            'Product Orientation': 'Horizontal',
            Finish: 'Embossed Gloss',
            Corners: 'Rounded Corners',
            'Connected Cards': 'None',
            Backsides: 'Blank',
        },
        dpcId: '36075408-80da-4351-a73d-44ee3c051b1c',
    },
    {
        label: 'Paper Bag - NA',
        productKey: 'PRD-NWX3BVPAQ',
        productVersion: 2,
        culture: 'en-us',
        documentSourceUri: 'https://storage.documents.cimpress.io/v3/documents/85789853-1920-46cb-97a1-d76c5e466ffb~200/revisions/23e86683-fcdc-4d1a-9271-e7b646d30a38~200',
        productOptions: {
            Size: 'Large',
            'Print Type': 'Full Color',
            'Paper Stock': '#d5b59c',
            'Decoration Area': 'All-Over Print',
            'Cord Type': 'Paper Cord White',
            'Branded Logo': 'No',
            Backside: 'Blank',
        },
    },
    {
        label: 'Posters - NA',
        productKey: 'PRD-HSKBMXYA',
        productVersion: 37,
        culture: 'en-us',
        documentSourceUri: SHARED_DOCUMENT_SOURCE_URI,
        productOptions: {
            Substrates: 'Glossy',
            Size: '8.5" X 11"',
            'Product Orientation': 'Horizontal',
            Lamination: 'No',
        },
        dpcId: '36075408-80da-4351-a73d-44ee3c051b1c',
    },
    {
        label: 'Retractable Banners - NA',
        productKey: 'PRD-NLRHYQSJ',
        productVersion: 72,
        culture: 'en-us',
        documentSourceUri: SHARED_DOCUMENT_SOURCE_URI,
        productOptions: {
            Size: 'Small Size',
            'Printed Sides': 'Single Sided',
            Material: 'Premium',
            Coating: 'None',
            'Cassette Color': '#000000',
            Cassette: 'Deluxe',
        },
        dpcId: '36075408-80da-4351-a73d-44ee3c051b1c',
    },
    {
        label: 'Roll Labels - NA',
        productKey: 'PRD-DF5PWTHC',
        productVersion: 58,
        culture: 'en-us',
        documentSourceUri: SHARED_DOCUMENT_SOURCE_URI,
        productOptions: {
            'White Layer': 'False',
            'Unwind Direction': 'Bottom of Copy',
            Size: '1.5"x1.5"',
            Shape: 'Circle',
            'Product Orientation': 'Horizontal',
            Material: 'Clear Plastic',
            Finish: 'Gloss',
        },
        dpcId: '36075408-80da-4351-a73d-44ee3c051b1c',
    },
];
